export const PageText = {
  _1: 'Personalised recommendations',
  _2: 'Based on the aircheckr air quality index, we also developed health-based recommendations. These are concrete & personal recommendations, that empower your customers to take actions if needed.'
};

export const Categories = {
  _1: {
    title: 'Empower',
    subcategories: [
      {
        key: 0,
        text: 'The aircheckr recommendations empower your customers. You can even alert people when specific thresholds are exceeded. Moreover, you can also integrate hints from aircheckr and provide people with tools to take actions themselves.'
      }
    ]
  },
  _2: {
    title: 'Personalised',
    subcategories: [
      {
        key: 0,
        text: 'Considering the level of sensitivity towards air pollution of a person',
        bulletItems: [
          {
            text: 'Sensitive: People with heart or respiratory disease, diabetes, elderly, children, pregnant women & people with complaints or prone to complaints'
          },
          {
            text: 'Non-sensitive: All the rest of the people'
          }
        ]
      },
      {
        key: 1,
        text: 'Considering the application you are doing/using',
        bulletItems: [
          {
            text: 'General'
          },
          {
            text: 'Sports or Exercise'
          },
          {
            text: 'Ventilation & A/C'
          }
        ]
      }
    ]
  }
};

export default PageText;



// WEBPACK FOOTER //
// ./src/input-text/en/help-and-guides/personalised-recommendations_page.js